import { defineQuery } from 'next-sanity'
import { imageFields, linkFields } from '../atoms'

export const regionCardsBlockFields = `
  _id,
  _type,
  title,
  items[]{
    _type,
    title,
    image {
      ${imageFields}
    },
    "link": link{
      ${linkFields}
    }
  }
`

export const REGION_CARDS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "region-cards-block"][0]{
    ${regionCardsBlockFields}
  }
`)
